import {
    SEND_SERVERSIDE_FPTI_ACTION,
    SERVERSIDE_FPTI_API,
    COMP,
    PROSPECT_PAYPAL_ACCOUNT_SIGNUP_IN_PROGRESS,
    PROSPECT_PAYPAL_ACCOUNT_SIGNUP_COMPLETE,
    NEW_CUSTOMER_VIEW_NAME
} from './FPTIConstants';

import axios from 'axios';
import _ from 'lodash';
import { getErrorFieldsAndMessages } from '../customMiddleware/fptiMiddleware';
import { inIframe } from '../../App/AppUtils';

export const sendServerSideFpti = data => {
    return (dispatch, getState) => {
        const { serverData = {} } = getState();
        const { _csrf = '' } = serverData;
        return axios
            .request({
                method: 'post',
                url: SERVERSIDE_FPTI_API,
                headers: {
                    'X-CSRF-Token': _csrf
                },
                data
            })
            .then(() => {
                // Dispatch action for logging, but may not be necessary to store in state
                return dispatch({
                    type: SEND_SERVERSIDE_FPTI_ACTION,
                    payload: {
                        fptiType: 'server',
                        timestamp: Date.now(),
                        data
                    }
                });
            })
            .catch(() => {
                // swallow any error as fpti should not affect the application
                return;
            });
    };
};

export const trackTransition = (
    stateName = 'unknown-state',
    transitionName = 'unknown-transition',
    extra = {}
) => dispatch => dispatch(sendServerSideFpti({
    ...extra,
    state_name: stateName,
    transition_name: transitionName
}));

/**
 * Record page name and impression for client side fpti
 */
export const recordImpression = (pageName, applicationResponse, applicationType) => {
    // don't log fpti if pa.js isn't loaded
    if (!_.has(window, 'PAYPAL.analytics')) {
        capeLog && capeLog('PAYPAL.analytics unavailable for fpti');
        return;
    }

    const fptiData = {
        data: getFPTIData(pageName, applicationResponse, applicationType)
    };

    const { erfd, erpg } = getErrorFieldsAndMessages();

    fptiData.data.erfd = erfd;
    fptiData.data.erpg = erpg;


    /**
     * Use record impression for on page load events in order to differentiate between
     * page events vs form field events (account activity AKA ac)
     */
    window.PAYPAL.analytics.Analytics.prototype.recordImpression(fptiData);
};

/**
 * Track click of any submit, button, anchor tags, send data to client FPTI.
 * @param event
 */
export const trackButtonAndLinkClick = (event, pageName) => {
    // don't log fpti if pa.js isn't loaded
    if (!_.has(window, 'PAYPAL.analytics')) {
        capeLog && capeLog('PAYPAL.analytics unavailable for fpti');
        return;
    }

    const fptiData = {
        data: getFPTIData(pageName)
    };

    const { erfd, erpg } = getErrorFieldsAndMessages();

    const { name, id, type, value, href } = event.target;
    const field = (name) ? name : ((id) ? id : '');
    fptiData.data.pgln = `${fptiData.data.pgrp}|${field}`;
    fptiData.data.pglk = `${fptiData.data.pgrp}|${field}`;
    fptiData.data.link = (field) ? field : value;
    fptiData.data.uitype = type;
    fptiData.data.lu = href;

    // On button click (transition to next page) we want to report any error fields & messages
    if (type === 'button') {
        fptiData.data.erfd = erfd;
        fptiData.data.erpg = erpg;
    }
    window.PAYPAL.analytics.Analytics.prototype.recordClick(fptiData);
};

/**
 * When a new paypal customer tries to sign up for a paypal account via CAPE flow, the prospect is set to 46. When the user successfully
 * signs up for a paypal account, then the prospect is 66. When he fails to sign up, no prospect value is sent.
 * @returns {number} prospect
 */
export const getPayPalAccountSignUpProspect = () => {
    if (window.viewName === NEW_CUSTOMER_VIEW_NAME) {
        return PROSPECT_PAYPAL_ACCOUNT_SIGNUP_IN_PROGRESS;
    } else {
        return window.prospectForPayPalAccountSignUp ? PROSPECT_PAYPAL_ACCOUNT_SIGNUP_COMPLETE : null;
    }
};

/**
 * Base function to pull together core set of FPTI client side data attributes
 * @param pageName
 */
export const getFPTIData = (pageName, applicationResponse, applicationType) => {
    const pageGroup = `main:${COMP}:${pageName}:::::`;
    /**
     * applicationStatus is pulled first from global var 'appStatus'
     * and then from redux serverData.decisionModel.applicationResponse
     */
    const applicationStatus = window.appStatus || applicationResponse || '';
    const page = `main:${COMP}:${pageName}:${applicationStatus}::::`;
    return {
        clid: COMP,
        flnm: window.flow,
        ccpg: window.country,
        channel: window.mobileorWebChannel,
        pgrp: pageGroup,
        page,
        fltp: (applicationType) ? applicationType : window.applyType,
        fltk: window.contextId,
        xt: window.pxpTrmntId,
        xe: window.pxpExpId,
        pros: getPayPalAccountSignUpProspect(),
        is_iframe: inIframe()
    };
};
